import { render, staticRenderFns } from "./IATCombo.vue?vue&type=template&id=fcfa79f4"
import script from "./IATCombo.vue?vue&type=script&lang=js"
export * from "./IATCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports